import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { Router } from '@angular/router';
import { getAllChildTagsForTd } from '@utils/other-utils';
import { Locale } from '@shared/models/locale';
import { tap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { CatalogImpairedView } from '../../models/table';
import { ImpairedDataSetSoringType, ImpairedDataSetSorting } from '../../models/data-table';
import { DataState } from '../../data-state.service';
import { OrderingType } from '../../../../../data/modules/catalog-data/components/ordering/models';
import { ImpairedCatalogItemsRoutes } from '../../modules/models/routes';
import { VersionForVisuallyImpairedRoutes } from '../../../../models/routes';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataTableComponent implements OnInit {
  @Input() public catalogs: CatalogImpairedView[];
  public nameSorting = ImpairedDataSetSoringType.ByName;
  public categorySorting = ImpairedDataSetSoringType.ByCategory;
  public provideSorting = ImpairedDataSetSoringType.ByProvide;
  public isRuLocale = true;
  public langChange$: Observable<LangChangeEvent>;
  public sorting: ImpairedDataSetSorting = {
    type: ImpairedDataSetSoringType.ByName,
    value: 'ASC'
  };
  public icons = CustomIcons;

  constructor(private dataState: DataState, private router: Router, private translateService: TranslateService) {}

  private setText(lang: Locale): void {
    if (lang === Locale.RU_RU) {
      this.isRuLocale = true;
    } else {
      this.isRuLocale = false;
    }
  }

  public ngOnInit(): void {
    this.setText(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setText(res.lang as Locale);
      })
    );
  }

  public changeSorting(type: ImpairedDataSetSoringType): void {
    if (type === this.sorting.type) {
      if (this.sorting.value === 'ASC') {
        this.sorting.value = 'DESC';
      } else {
        this.sorting.value = 'ASC';
      }
    } else {
      this.sorting = {
        type: type,
        value: 'ASC'
      };
    }

    // eslint-disable-next-line default-case
    switch (this.sorting.type) {
      case ImpairedDataSetSoringType.ByName: {
        this.dataState.sorting.next({ [OrderingType.ByCatalogName]: this.sorting.value });
        break;
      }
      case ImpairedDataSetSoringType.ByCategory: {
        this.dataState.sorting.next({ [OrderingType.ByCategoryName]: this.sorting.value });
        break;
      }
      case ImpairedDataSetSoringType.ByProvide: {
        this.dataState.sorting.next({ [OrderingType.ByProviderName]: this.sorting.value });
        break;
      }
    }
  }

  public openCatalog(target: EventTarget | null, catalog: CatalogImpairedView): void {
    const topTags = ['APP-DOWNLOAD-BUTTON'];
    const parentTags = getAllChildTagsForTd(topTags, target as HTMLElement);
    if (!parentTags.some(parentTag => topTags.some(topTag => topTag === parentTag))) {
      this.router.navigate(
        [`/visually-impaired/${VersionForVisuallyImpairedRoutes.DataSet}`, catalog.id, `${ImpairedCatalogItemsRoutes.Table}`],
        {
          queryParams: { isDynamic: catalog.isDynamic }
        }
      );
    }
  }
}
